;(() => {
  const dismissedValue = 'dismissed'

  const getStoredValue = (key) => {
    try {
      return window.localStorage.getItem(key)
    } catch (_error) {
      return null
    }
  }

  const setStoredValue = (key, value) => {
    try {
      window.localStorage.setItem(key, value)
    } catch (_error) {
      // The bar remains dismissible when browser storage is unavailable.
    }
  }

  const initializeAnnouncementBar = (bar) => {
    if (bar.dataset.announcementInitialized === 'true') return

    const dismissKey = bar.dataset.dismissKey
    if (dismissKey && getStoredValue(dismissKey) === dismissedValue) {
      bar.hidden = true
      return
    }

    const marquee = bar.querySelector('marquee-loop')
    const toggleButton = bar.querySelector('[data-announcement-toggle]')
    const toggleLabel = bar.querySelector('[data-announcement-toggle-label]')
    const dismissButton = bar.querySelector('[data-announcement-dismiss]')

    const setPausedState = (isPaused) => {
      marquee?.classList.toggle('is-paused', isPaused)
      toggleButton?.classList.toggle('announcement-strip__play-toggle--paused', isPaused)
      toggleButton?.setAttribute('aria-pressed', String(isPaused))
      toggleButton?.setAttribute('aria-label', isPaused ? 'Play announcement ticker' : 'Pause announcement ticker')
      if (toggleLabel) toggleLabel.textContent = isPaused ? 'Play announcement ticker' : 'Pause announcement ticker'
    }

    toggleButton?.addEventListener('click', () => {
      setPausedState(!marquee?.classList.contains('is-paused'))
    })

    dismissButton?.addEventListener('click', () => {
      if (dismissKey) setStoredValue(dismissKey, dismissedValue)
      bar.hidden = true
    })

    bar.dataset.announcementInitialized = 'true'
  }

  const initializeAnnouncementBars = (root = document) => {
    root.querySelectorAll('[data-announcement-bar]').forEach(initializeAnnouncementBar)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAnnouncementBars())
  } else {
    initializeAnnouncementBars()
  }

  document.addEventListener('shopify:section:load', (event) => initializeAnnouncementBars(event.target))
})()
